exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delete-packages-form {\n  min-height: 120px;\n}\n.delete-packages-form .ant-picker {\n  width: 100%;\n}\n.delete-packages-form .package-count {\n  font-size: 11px;\n  color: #9ba0aa;\n}\n.delete-packages-form .package-count .ant-spin {\n  margin-left: 2px;\n}\n.delete-packages-form .no-packages-found {\n  font-size: 11px;\n  color: #ff4d4f;\n}\n", ""]);

// exports
